<template>
  <div>
      <div class="flex flex-col sm:flex-row sm:items-center gap-4 mb-6">
          <!-- Botão Adicionar Modelo -->
          <button @click="$emit('show-add-model-modal')"
              class="w-full md:w-auto bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 font-medium shadow-lg whitespace-nowrap">
              <PlusCircle class="w-5 h-5" />
              <span>Adicionar Modelo</span>
          </button>
          <input v-model="filterName" type="text"
              placeholder="Filtrar por nome do modelo"
              class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
      </div>

      <!-- Tabela de Modelos (Desktop) -->
      <div class="hidden md:block overflow-x-auto bg-white dark:bg-gray-800 rounded-lg shadow">
          <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead class="bg-blue-500 dark:bg-blue-600 text-white dark:text-gray-300 text-sm uppercase tracking-wide">
                  <tr>
                      <th v-for="header in ['Nome do Modelo', 'Marca', 'Tipo', 'Ações']" :key="header"
                          class="py-4 px-6 text-left">
                          {{ header }}
                      </th>
                  </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                  <tr v-for="model in filteredModels" :key="model.id"
                      class="hover:bg-gray-50 dark:hover:bg-gray-700">
                      <td class="py-4 px-6 text-sm font-medium text-gray-900 dark:text-white">
                          {{ model.nome }}
                      </td>
                      <td class="py-4 px-6 text-sm text-gray-500 dark:text-gray-400">
                          {{ model.marca }}
                      </td>
                      <td class="py-4 px-6 text-sm text-gray-500 dark:text-gray-400">
                          {{ model.tipo }}
                      </td>
                      <td class="py-4 px-6 text-sm font-medium">
                          <button @click="$emit('edit-model', model)"
                              class="text-blue-600 hover:text-blue-900 dark:text-blue-500 dark:hover:text-blue-400 mr-3">
                              <Edit2 class="w-5 h-5" />
                          </button>
                          <button @click="$emit('delete-model', model)"
                              class="text-red-600 hover:text-red-900 dark:text-red-500 dark:hover:text-red-400">
                              <Trash2 class="w-5 h-5" />
                          </button>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>

      <!-- Cards de Modelos (Mobile) -->
      <div class="block md:hidden space-y-4">
          <div v-for="model in filteredModels" :key="model.id"
               class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
              <!-- Nome do Modelo -->
              <div class="flex items-center space-x-2">
                  <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Nome:</span>
                  <span class="text-sm text-gray-500 dark:text-gray-400">{{ model.nome }}</span>
              </div>
              <!-- Marca -->
              <div class="flex items-center space-x-2">
                  <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Marca:</span>
                  <span class="text-sm text-gray-500 dark:text-gray-400">{{ model.marca }}</span>
              </div>
              <!-- Tipo -->
              <div class="flex items-center space-x-2">
                  <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Tipo:</span>
                  <span class="text-sm text-gray-500 dark:text-gray-400">{{ model.tipo }}</span>
              </div>
              <!-- Botões de Ação -->
              <div class="flex justify-end space-x-2 mt-2">
                  <button @click="$emit('edit-model', model)"
                      class="text-blue-600 hover:text-blue-900 dark:text-blue-500 dark:hover:text-blue-400">
                      <Edit2 class="w-5 h-5" />
                  </button>
                  <button @click="$emit('delete-model', model)"
                      class="text-red-600 hover:text-red-900 dark:text-red-500 dark:hover:text-red-400">
                      <Trash2 class="w-5 h-5" />
                  </button>
              </div>
          </div>
      </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { Edit2, Trash2, PlusCircle } from 'lucide-vue-next';
import apiClient from '@/services/authService';

const models = ref([]);
const filterName = ref('');

const fetchModels = async () => {
    try {
        const params = {};
        const searchTerm = filterName.value.trim();
        if (searchTerm) {
            params.search = searchTerm;
        }
        const response = await apiClient.get('/api/v1/actives/models/', { params });
        models.value = response.data;
    } catch (error) {
        console.error("Erro ao buscar modelos:", error);
    }
};

const filteredModels = computed(() => models.value);

let searchTimer = null;
watch(filterName, () => {
    if (searchTimer) clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
        fetchModels();
    }, 300);
});

onMounted(() => {
    fetchModels();
});
</script>
